import axiosInstance from "../utils/axiosInstance";

interface GetJobOutputTextResponse {
  text?: string;
  contentTextKey?: string;
}

export interface JobOutputTextResult {
  text: string;
  contentTextKey: string;
}

export const getJobOutputText = async (jobId: string): Promise<JobOutputTextResult> => {
  try {
    const response = await axiosInstance.get<GetJobOutputTextResponse>(`/jobs/${jobId}/output-text`);
    return {
      text: response.data.text?.trim() || "",
      contentTextKey: response.data.contentTextKey?.trim() || "",
    };
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to load output text.");
  }
};
